import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { type AdvisoryNeedDto, type AdvisoryNeedRequestDto, createAdvisoryNeed } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useCreateAdvisoryNeed = (): UseMutationResult<AdvisoryNeedDto, AxiosError, AdvisoryNeedRequestDto> => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (event) => createAdvisoryNeed({ body: event }).then((res) => res.data!),
        onSuccess: (savedAdvisoryNeed) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.advisoryNeeds() });
            showSuccessToast(t('successActionGeneric'));
            navigate({
                pathname: '/content-admin/advisory-needs',
                search: `?adv-need=${savedAdvisoryNeed.id}`,
            });
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureActionGeneric') }),
    });
};
